import {VisibilityChecker} from './VisibilityChecker';
import {VideoVisibilityCheckerHandler} from './VideoVisibilityChecker';

export class PartialsLoader {
	private _boundListener: () => void = this._onScroll.bind(this);
	private _partialLoaders: PartialLoader[] = [];

	static init() {
		document.addEventListener('DOMContentLoaded', () => {
			new PartialsLoader();
		});
	}

	constructor() {
		this._setOnscrollEvents();
		this.init();
	}

	elements() {
		return document.body.querySelectorAll('[data-widget=partial_loader]');
	}
	private init() {
		const elements = this.elements();
		for (let i = 0; i < elements.length; i++) {
			const element = elements[i] as HTMLElement;
			const partialLoader = new PartialLoader(element);
			this._partialLoaders.push(partialLoader);
		}

		this._onScroll();
	}
	private _setOnscrollEvents() {
		window.addEventListener('scroll', this._boundListener, false);
	}

	private _onScroll() {
		this._checkElementsVisibility();
	}
	private _checkElementsVisibility() {
		for (let i = 0; i < this._partialLoaders.length; i++) {
			const partialLoader = this._partialLoaders[i];

			if (partialLoader.isVisible()) {
				partialLoader.load();
			}
		}
	}
}

class PartialLoader {
	private _loading: boolean = false;
	private _loaded: boolean = false;

	constructor(private _element: HTMLElement) {}

	isVisible() {
		return VisibilityChecker.isElementFullyInViewport(this._element);
	}

	async load() {
		if (this._loaded || this._loading) {
			return;
		}

		this._loading = true;
		const url = this._element.dataset['url'];
		try {
			if (url) {
				const response = await fetch(url);
				if (response.ok) {
					const text = await response.text();
					this._element.innerHTML = text;
					this._loaded = true;

					VideoVisibilityCheckerHandler.reset();
				}
			}
		} catch (error) {
			console.warn(`failed to load ${url}`);
		}
	}
}
